import { z } from "zod";

/**
 * `GET /api/settings` (ADR-133 point 3): what the portal needs to know before anyone signs in.
 * Public, without a session, answered with `Cache-Control: no-store` so a changed setting holds
 * at the next load. `guestCatalog` follows `GUEST_CATALOG_ENABLED` at the API: false, the
 * catalogue needs a session (`GET /api/products` answers `401 unauthenticated`), and the portal
 * sends guests from catalogue and product page to the login. Whether the customer may order
 * themselves is no setting here: the session's `permissions` and the `actions` say so.
 */
export const PortalSettings = z.object({
  guestCatalog: z.boolean(),
});
export type PortalSettings = z.infer<typeof PortalSettings>;
